import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

// ICON NAMES - Adding a name here will effectively register a new icon
// If it's a Material Icon, keep the name from the Material icons website (+ suffix,
// e.g. _outline)

const ICON_NAMES: string[] = [
  '24h_updates',
  'account_circle',
  'account_circle_outline',
  'add',
  'add_circle_outline',
  'ai_generate',
  'ai_generate_new',
  'analytics',
  'analytics_filled',
  'apple',
  'archive_locations',
  'arrow_back',
  'arrow_downward',
  'arrow_drop_down',
  'arrow_drop_up',
  'arrow_forward',
  'arrow_insert',
  'arrow_upward',
  'autorenew',
  'batch_modify_location_groups',
  'blacklist_locations',
  'bulk_accept_differences',
  'bulk_validate_completed',
  'bulk_validate_idle',
  'bulk_validate_in_progress',
  'cached',
  'call',
  'cancel',
  'category_outline',
  'cc_results',
  'cc_search',
  'cc_sync',
  'cc_sync_fail',
  'cc_sync_finish',
  'cc_sync_process',
  'check_circle',
  'check_circle_outline',
  'chevron_down',
  'chevron_left',
  'chevron_right',
  'chevron_up',
  'class_outline',
  'clear',
  'clear_sorting',
  'close',
  'comment',
  'comment_outline',
  'commented_not_responded',
  'commented_responded',
  'compare_arrows',
  'content_copy',
  'cookie',
  'custom_pin',
  'data_sync_status_failed',
  'data_sync_status_finished',
  'data_sync_status_inconclusive',
  'data_sync_status_nosync12h',
  'data_sync_status_pending',
  'data_sync_status_warning',
  'date_range',
  'delete_outline',
  'dock_to_left',
  'done',
  'download_reviews',
  'dynamic_feed',
  'edit',
  'edit_location_outlined',
  'edit_outline',
  'edit_square',
  'error',
  'error_outline',
  'event',
  'event_available',
  'event_available_outline',
  'export_differences',
  'export_locations',
  'export_to_csv',
  'export_to_sheet',
  'facebook',
  'facebook_color',
  'facebook_comment',
  'facebook_share',
  'feedback',
  'fiber_manual_record',
  'fiber_manual_record_outline',
  'filter_alt_off_outline',
  'filter_alt_outline',
  'filter_list_alt',
  'fingerprint',
  'flag',
  'focus_custom_coords',
  'focus_geocoded_coords',
  'focus_imported_coords',
  'format_list_bulleted',
  'gbp_coordinates_marker',
  'get_gmb_updates',
  'gps_fixed',
  'groups_outlined',
  'gxperts',
  'help_outline',
  'house_outline',
  'highlight_off',
  'history',
  'home',
  'home_filled',
  'import_locations',
  'info',
  'info_outline',
  'insert_emoticon',
  'insights_empty_state',
  'instagram',
  'instagram_color',
  'instagram_like',
  'instagram_comment',
  'instagram_repost',
  'instagram_save',
  'instagram_share',
  'keyboard_outline',
  'label_outline',
  'landing_pages',
  'language',
  'lens',
  'link',
  'linkedin',
  'linkedin_color',
  'linkedin_like',
  'linkedin_comment',
  'linkedin_repost',
  'linkedin_send',
  'link_off',
  'local_offer_outline',
  'like',
  'location',
  'location_filled',
  'locations_empty_state',
  'location_city',
  'location_on_outline',
  'location_placeholder',
  'logout',
  'mail_outline',
  'manage_accounts_outline',
  'map_outlined',
  'mark_duplicate',
  'mark_duplicate_full',
  'maximize_pin',
  'menu',
  'minimize_pin',
  'more_horizontal',
  'more_vert',
  'new_releases_outline',
  'not_listed_location_outline',
  'not_responded',
  'notes',
  'notification',
  'open_in_new',
  'outlined_flag',
  'partial_connection',
  'pending_outline',
  'people',
  'people_filled',
  'person_add_outline',
  'photo_library_outline',
  'pinterest',
  'pin_filled',
  'pin_outline',
  'place_outline',
  'places_logo',
  'platforms',
  'post_add',
  'post_small',
  'posts',
  'posts_filled',
  'public',
  'question',
  'question_filled',
  'questions_empty',
  'rating_only_not_responded',
  'rating_only_responded',
  'refresh',
  'remove_circle_outline',
  'reply_templates',
  'report_problem',
  'report_problem_outline',
  'resize_columns',
  'reset_columns',
  'review_download_empty_state',
  'review_templates_empty',
  'reviewed',
  'reviews',
  'reviews_filled',
  'reviews_empty',
  'reviews_outline',
  'save_outline',
  'save_draft_as_template',
  'search',
  'share',
  'sms_failed_outline',
  'sort',
  'sorting_ascending',
  'sorting_descending',
  'spellcheck',
  'star',
  'starred_all_locations',
  'starred_filtered',
  'starred_selected',
  'starred_unlinked',
  'star_border',
  'star_half',
  'star_rating',
  'sticky_note_empty_add',
  'sticky_note_info',
  'sticky_note_with_content',
  'storefront_outline',
  'support',
  'sync',
  'tiktok',
  'toggle_bottom_panel',
  'toggle_right_panel',
  'touch',
  'translate',
  'trending_down',
  'trending_flat',
  'trending_up',
  'tune',
  'twitter',
  'x_comment',
  'x_like',
  'x_repost',
  'x_share',
  'undo',
  'unpin',
  'update',
  'update_in_gmb',
  'upload_reply_templates',
  'users_group',
  'validated_coordinates_marker',
  'validation_history',
  'verified_user',
  'verified_user_outlined',
  'view_week_outline',
  'visibility',
  'visibility_off',
  'visibility_off_outline',
  'visibility_outline',
  'watch_later_outline',
  'whatsapp',
  'where_to_vote_outlined',
  'whitelist_locations',
  'year_in_review',
  'youtube',
  'download',
];

const PATH_TO_MIN_ICONS_FOLDER = 'assets/images/icon-min/';

@Injectable({
  providedIn: 'root',
})

export class IconRegistryService {
  constructor(private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer) {
    // will only run if at least one class injects this service https://github.com/angular/angular/issues/25633
    // since this is a singleton service (providedIn: 'root'), will be called only once
    this.registerIcons();
  }

  private registerIcons() {
    for (let iconName of ICON_NAMES) {
      this.matIconRegistry
          .addSvgIcon(
              iconName,
              this.domSanitizer.bypassSecurityTrustResourceUrl(PATH_TO_MIN_ICONS_FOLDER + iconName + '.svg'));
    }
  }

}
